module.exports = __webpack_public_path__ + "assets/learn-1.3a246dd1.svg";